import React from 'react'

import { type SxProps } from '@mui/material/styles'
import { AccountBalance, ChevronRight } from '@mxenabled/mx-icons'

import { P, H3, Text } from '@mxenabled/mxui'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'

import { ConnectDrawer, useAppConfig, useGlobalCopyStore } from '../../common'
import ConnectionsDrawer from '../../accounts/components/ConnectionsDrawer'

interface ConnectMoreAccountsCardProps {
  drawerType?: 'connectDrawer' | 'connectionsDrawer'
  isDashboard?: boolean
  hasIcon?: boolean
  buttonText?: string
  title?: string
  titleDrawer?: string
  description?: string
  sx?: SxProps
}

export const ConnectMoreAccountsCard = ({
  drawerType,
  isDashboard = false,
  hasIcon = true,
  buttonText,
  title,
  titleDrawer,
  description,
  sx,
}: ConnectMoreAccountsCardProps) => {
  const [showConnectWidget, setShowConnectWidget] = React.useState(false)
  const { connect: connectCopy, finstrong: copy } = useGlobalCopyStore()
  const { config } = useAppConfig()
  return drawerType && config.show_connections_widget_in_master ? (
    <Card
      sx={{
        pb: 24,
        pt: 18,
        px: 24,
        width: '100%',
        ...sx,
      }}
    >
      <Stack
        sx={{
          gap: 8,
          ...(isDashboard && { flexDirection: 'row', alignItems: 'center' }),
        }}
      >
        {hasIcon && <AccountBalance sx={{ height: 20, width: 20 }} />}
        <H3 className="connect-more-accounts-title" sx={{ ...(isDashboard && { fontSize: 15 }) }}>
          {title ? title : copy.connect_more_accounts_title}
        </H3>
      </Stack>
      <P
        className="connect-more-accounts-description"
        sx={{ color: 'text.secondary', mt: 8 }}
        variant="subtitle1"
      >
        {description ? description : copy.connect_more_accounts_description}
      </P>

      <Button
        endIcon={<ChevronRight />}
        onClick={() => setShowConnectWidget(true)}
        size="small"
        sx={{ p: 0, mt: 8, '&:hover': { backgroundColor: 'transparent' } }}
      >
        <Text sx={{ fontWeight: 600 }} variant="body2">
          {buttonText ? buttonText : copy.connect_more_accounts_button}
        </Text>
      </Button>

      {drawerType === 'connectDrawer' && (
        <ConnectDrawer
          onClose={() => setShowConnectWidget(false)}
          showConnectWidget={showConnectWidget}
          title={titleDrawer ? titleDrawer : connectCopy.mini_title}
        />
      )}
      {drawerType === 'connectionsDrawer' && (
        <ConnectionsDrawer
          onClose={() => setShowConnectWidget(false)}
          showConnectionsWidget={showConnectWidget}
          title={titleDrawer ? titleDrawer : connectCopy.mini_title}
        />
      )}
    </Card>
  ) : null
}
